/* عميل Supabase الوحيد - يقرأ المفاتيح من .env.local (VITE_*).
   لا تضعي المفتاح داخل الشيفرة؛ ضعيه في .env.local غير المرفوع لـ git. */
import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anon) {
  // رسالة واضحة بدل انهيار غامض
  console.error("[tpms] مفاتيح Supabase مفقودة - أنشئ src/../.env.local وأضف VITE_SUPABASE_URL و VITE_SUPABASE_ANON_KEY ثم أعد التشغيل.");
}

export const supabase = createClient(url || "http://localhost", anon || "anon", {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
});

export const hasSupabaseKeys = !!(url && anon);
